import React from 'react';
import { QUESTION_STATUS } from '../../enum';
import './index.scss';
export const QuestionUnitLi = (props) => {
    const hasShowImg = props.imageUrls.length > 0 || props.surfacePlot;
    return (
        <div className="response-unit-li-box">
            <a href={`/question/detail/${props.id}`} hidden={!hasShowImg} className="question-img">
                <img src={props.imageUrls.length > 0 ? props.imageUrls[0]['imageUrl'] : props.surfacePlot} alt="" />
            </a>
            <div className="question-info-box">
                <div className="question-title-tag">
                    <h3><a href={`/question/detail/${props.id}`}>{substrTit(props.title)}</a></h3>
                    <p className="question-tag-box">
                        <span className="answer-tag"><i>答</i>{props.answerSum}</span><span className="collect"><i></i>{props.collectSum}</span>
                    </p>
                    <p className="questStatus" style={props.status === 1 ? { color: '#FF8800' } : props.status === 3 ? { color: '#FF3B30' } : props.status === 2 ? { color: '#B1B1B1' } : { color: '#222222' }}>{QUESTION_STATUS[props.status]}{props.status === 3 && ':' + props.auditDescription}</p>
                    <p className="question-date">{props.releaseTime}</p>
                </div>
                <div className="question-li-button-box">{
                    // tslint:disable-next-line: jsx-no-lambda
                    <a onClick={() => props.checkAnswer(props.id, props.questionProductId)} className="response-button">回答</a>}
                    {
                        // tslint:disable-next-line: jsx-no-lambda
                        <a onClick={() => props.delQuestion(props.id)} className="response-button">删除</a>}
                </div>
            </div>
        </div>
    );
};

function substrTit(title) {
    if (title.length > 113) {
        return title.substr(0, 113) + '...';
    }
    return title;
}
